import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import logo from '../../assets/logo.svg'
import { Path } from '../../router/BaseRouter/enums'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { localeSelector, userOptionsActions } from '../../store/slices/userOptionsSlice'
import { CustomerSearch } from './CustomerSearch'

export const Header: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const locale = useAppSelector(localeSelector)

  const toggleLocale = () => {
    dispatch(userOptionsActions.updateLocale(locale === 'en' ? 'cs' : 'en'))
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
      <Box>
        <Button
          variant="text"
          size="small"
          sx={{
            '&:hover': {
              background: 'none',
            },
          }}
          onClick={() => navigate(Path.HOME)}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <img src={logo} alt="School Buky" style={{ height: 28 }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: (theme) => theme.palette.text.primary }}>
              {t('title')}
            </Typography>
          </Box>
        </Button>
      </Box>
      <CustomerSearch />
      <Button variant="text" size="small" onClick={toggleLocale} sx={{ minWidth: 36, fontSize: 20 }}>
        {locale === 'en' ? '🇨🇿' : '🇬🇧'}
      </Button>
    </Box>
  )
}
